import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { GutachtenServiceModule } from '..';
import { GutachtenListComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    GutachtenServiceModule
  ],
  declarations: [GutachtenListComponent],
  exports: [GutachtenListComponent],

})
export class GutachtenListComponentModule { }
